import type { RingFinish } from '@jouzen/ecom-components/v3/types/ringFinish';

import type CurrentRouteValues from '@/app/[locale]/product/_hooks/useCurrentRoute/types';
import type { GetStyleStockStatus } from '@/app/[locale]/product/_hooks/useProductsInventory';
import { SELECT_SIZE, SIZING_KIT } from '@/app/[locale]/store/_consts';
import {
  GEN3_POP_PATHNAME,
  STORE_ACCESSORIES_ROOT_PATH,
  STORE_POP_PATHNAME,
} from '@/app/consts/pathnames';
import { type RingStyleEnum } from '@/app/enums/RingStyleEnum';

import WizStepId from '../enums/WizStepId';

interface GetHref {
  currentRoute: CurrentRouteValues | undefined;
  currentStep: WizStepId | undefined;
  getFirstStockedFinish: (props: GetStyleStockStatus) => RingFinish;
}

export const getHref = ({
  currentRoute,
  currentStep,
  getFirstStockedFinish,
}: GetHref): string => {
  const basePath =
    currentStep === WizStepId.Accessory
      ? STORE_POP_PATHNAME
      : GEN3_POP_PATHNAME;
  if (!currentRoute) return basePath;
  const accessory = currentRoute.accessory;
  const style = currentRoute.style;
  const finish = currentRoute.finish;
  const stockedFinish = getFirstStockedFinish({
    style: style.value as RingStyleEnum,
  });
  const size = currentRoute.size;
  const href = [GEN3_POP_PATHNAME, style.value] as string[];

  switch (currentStep) {
    case WizStepId.Accessory:
      return `${STORE_ACCESSORIES_ROOT_PATH}/${accessory.value}/${SELECT_SIZE}`;
    case WizStepId.Style:
      href.push(finish.value.length ? finish.value : stockedFinish);
      break;
    case WizStepId.Finish:
      href.push(finish.value.length ? finish.value : stockedFinish);
      href.push(size.value.length ? size.value : SIZING_KIT);
      break;
    case WizStepId.Size:
      href.push(finish.value);
      href.push(size.value);
      break;
  }

  return href.join('/');
};
